export default "__VITE_ASSET__5IAEB3Oq__"